import { url } from '@js/utilities/url.js'

// lodash components
import isEmpty from 'lodash/isEmpty'

export async function submit(inputData) {
    if (!isEmpty(inputData['dob'])) {
        const dobParts = inputData['dob'].split('/')

        inputData['dob_day'] = dobParts[1]
        inputData['dob_month'] = dobParts[0]
        inputData['dob_year'] = dobParts[2]

        delete inputData['dob']
    }

    if (!isEmpty(inputData['co_app_dob'])) {
        const coOpDobParts = inputData['co_app_dob'].split('/')

        inputData['co_app_dob_day'] = coOpDobParts[1]
        inputData['co_app_dob_month'] = coOpDobParts[0]
        inputData['co_app_dob_year'] = coOpDobParts[2]

        delete inputData['co_app_dob']
    }

    if (!isEmpty(inputData['social_security_number'])) {
        inputData['social_security_number'] = inputData['social_security_number'].replace(/-/g, '')
    }

    return axios.post(url('/monevo/apply'), inputData)
}
